import 'selectric';

export const selectricInit = ($select = $('.js-custom-select'), config = {}) => {
  $select.selectric(config);
};
